var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("title", function () {
        return [_c("text-header", [_vm._v("Банковские реквизиты поставщика")])]
      }),
      _vm._t("info"),
      _c("text-row", {
        attrs: {
          value: _vm.supplier_accounting.bank_type.title,
          compact: "",
          label: "Вид обслуживающей организации",
        },
      }),
      _c("text-row", {
        attrs: { compact: "", label: "БИК банка" },
        model: {
          value: _vm.supplier_accounting.bik,
          callback: function ($$v) {
            _vm.$set(_vm.supplier_accounting, "bik", $$v)
          },
          expression: "supplier_accounting.bik",
        },
      }),
      _c("text-row", {
        attrs: { compact: "", label: "Название банка" },
        model: {
          value: _vm.supplier_accounting.bank_name,
          callback: function ($$v) {
            _vm.$set(_vm.supplier_accounting, "bank_name", $$v)
          },
          expression: "supplier_accounting.bank_name",
        },
      }),
      _c("text-row", {
        attrs: { compact: "", label: "Город банка" },
        model: {
          value: _vm.supplier_accounting.bank_city,
          callback: function ($$v) {
            _vm.$set(_vm.supplier_accounting, "bank_city", $$v)
          },
          expression: "supplier_accounting.bank_city",
        },
      }),
      _c("text-row", {
        attrs: { compact: "", label: "Кор. счет" },
        model: {
          value: _vm.supplier_accounting.ks,
          callback: function ($$v) {
            _vm.$set(_vm.supplier_accounting, "ks", $$v)
          },
          expression: "supplier_accounting.ks",
        },
      }),
      _c("text-row", {
        attrs: { compact: "", label: "Расчетный счет" },
        model: {
          value: _vm.supplier_accounting.rs,
          callback: function ($$v) {
            _vm.$set(_vm.supplier_accounting, "rs", $$v)
          },
          expression: "supplier_accounting.rs",
        },
      }),
      _vm.supplier_accounting.bank_type !== "bank"
        ? _c("text-row", {
            attrs: { compact: "", label: "Лицевой счет" },
            model: {
              value: _vm.supplier_accounting.ls,
              callback: function ($$v) {
                _vm.$set(_vm.supplier_accounting, "ls", $$v)
              },
              expression: "supplier_accounting.ls",
            },
          })
        : _vm._e(),
      _vm.supplier_accounting.bank_type !== "bank"
        ? _c("text-row", {
            attrs: { compact: "", label: "ИНН финансового органа" },
            model: {
              value: _vm.supplier_accounting.fo_inn,
              callback: function ($$v) {
                _vm.$set(_vm.supplier_accounting, "fo_inn", $$v)
              },
              expression: "supplier_accounting.fo_inn",
            },
          })
        : _vm._e(),
      _vm.supplier_accounting.bank_type !== "bank"
        ? _c("text-row", {
            attrs: {
              compact: "",
              label: "Полное наименование финансового органа",
            },
            model: {
              value: _vm.supplier_accounting.fo_name,
              callback: function ($$v) {
                _vm.$set(_vm.supplier_accounting, "fo_name", $$v)
              },
              expression: "supplier_accounting.fo_name",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }